import type { ComponentProps } from 'react';
import { FieldInfo, Select, useFieldContext } from './shared';
import { Label } from '../label';

export default function SelectTextField({
	label,
	options,
	className,
	...props
}: ComponentProps<'select'> & {
	label: string;
	options: { value: string; label: string }[];
	variant?: 'default' | 'outline';
}) {
	const field = useFieldContext<string>();

	return (
		<div className={className}>
			<div className="text-muted-foreground relative">
				{label && (
					<Label
						data-slot="form-label"
						data-error={field.state.meta.isTouched && !field.state.meta.isValid}
						className="data-[error=true]:text-destructive floating pointer-events-none w-full truncate px-3.5 py-[17px]"
						htmlFor={field.name}
					>
						{label}
					</Label>
				)}
				<Select
					id={field.name}
					name={field.name}
					value={field.state.value}
					onBlur={field.handleBlur}
					onChange={(e) => field.handleChange(e.target.value)}
					{...props}
				>
					<option value=""></option>
					{options.map((option) => (
						<option key={option.value} value={option.value}>
							{option.label}
						</option>
					))}
				</Select>
			</div>
			<FieldInfo fieldState={field.state} />
		</div>
	);
}
